'use client';
import { IoArrowForwardOutline } from "react-icons/io5";
import { getCdnUrl } from '@/utils/cdn';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function ImageSection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	const variants = {
		hidden: { opacity: 0, y: 50 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<section ref={ref} className="px-6 md:px-14 md:py-24 pb-10 pt-8 sm:pt-0 bg-white ">
			<motion.div
				variants={variants}
				initial="hidden"
				animate={isInView ? 'visible' : 'hidden'}
				transition={{ duration: 0.5, delay: 0.2 }}
				className="md:hidden block"
			>
				<p className="bg-forbli-green text-white w-[190px] text-center py-0.5">
					Em breve!
				</p>
				<div className="bg-[#f0f0f0] py-4 px-6 mt-2 rounded-2xl mb-6">
					<h2 className="text-2xl md:text-4xl text-[#0f172a]  mb-4 sm:mb-4">
						Unidades com subsídio<br />
						Minha casa Minha Vida.
					</h2>
					<button className="inline-flex items-center gap-3 mb-6 bg-forbli-green hover:bg-black text-white px-1.5 py-1.5  rounded-full  transition-colors group text-sm">
						<span className="pl-8">Conheça</span>
						<div className="w-9 h-9 bg-[#ccf03e] rounded-full flex items-center justify-center group-hover:rotate-45 transition-all delay-300">
							<IoArrowForwardOutline size={20} className="text-black" />
						</div>
					</button>
				</div>
			</motion.div>
			<div className="relative rounded-[32px] overflow-hidden h-[65vh] md:h-[80vh] mx-auto max-w-8xl">
				{/* Vídeo de fundo */}
				<video
					src={getCdnUrl("/videos/barbacena.mp4")}
					className="absolute inset-0 w-full h-full object-cover"
					autoPlay
					muted
					loop
					playsInline
					preload="auto"
				/>
				{/* Overlay escuro para legibilidade */}
				<div className="absolute inset-0 bg-black/20" />

				{/* Card no canto superior esquerdo */}

				<motion.div
					variants={variants}
					initial="hidden"
					animate={isInView ? 'visible' : 'hidden'}
					transition={{ duration: 0.5, delay: 0.4 }}
					className="z-10 absolute top-4 left-4 md:top-12 md:left-32 md:block hidden"
				>
					<div className="bg-white/95 backdrop-blur-sm rounded-4xl py-4  md:py-8 md:px-12 shadow-xl border border-white/30 md:w-[600px]">

						<p className="text-gray-800 text-sm ">Em breve</p>


						<h2 className="text-lg sm:text-xl md:text-4xl text-[#0f172a] leading-tight mb-4 sm:mb-4">
							Unidades com subsídio<br />
							Minha casa Minha Vida.
						</h2>


						<button className="inline-flex items-center gap-3 bg-forbli-green hover:bg-black text-white px-1.5 py-1.5  rounded-full  transition-colors group text-sm">
							<span className="pl-8">Saiba mais</span>
							<div className="w-9 h-9 bg-[#ccf03e] rounded-full flex items-center justify-center group-hover:rotate-45 transition-all delay-300">
								<IoArrowForwardOutline size={20} className="text-black" />
							</div>
						</button>
					</div>
				</motion.div>
			</div>
		</section>
	);
}